
import { cssrs_catalog } from "../../../../escalas/cssrs/cssrs.catalog";

export default function CssrsResults({ cssrs }) {
    return (
        <div>
            {/* {JSON.stringify(cssrs)} */}
            {
                cssrs_catalog.map((item, index) => (
                    <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                        <td>{item}</td>
                        <td>{cssrs[index] ? "Si" : "No"}</td>
                    </tr>
                ))
            }
        </div>
    )
}